import { createApi } from "@reduxjs/toolkit/query/react";
import {AnalyticalTreeMapInfo} from "features/analyticalTreeMap/types/analyticalTreeMap";
import { DateFilter } from "shared/types/filters";
import { baseAppQuery } from "shared/api/baseQuery";
import { formatDateUi } from "shared/utils/converters";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";

const ENDPOINT = "/analytics";
const analyticalTreeMapApi: any = createApi({
    reducerPath: "analyticalTreeMapApi",
    baseQuery: baseAppQuery,
    keepUnusedDataFor: 0,
    refetchOnMountOrArgChange: true,
    tagTypes: ["analyticalTreeMap"],
    endpoints: (builder) => ({
        getAnalytics: builder.query<AnalyticalTreeMapInfo[], DateFilter>({
            query: (filter) => {
                const queryParams = new URLSearchParams();
                queryParams.set("from", formatDateUi(filter?.dateFrom));
                queryParams.set("to", formatDateUi(filter?.dateTo));
                return `${ENDPOINT}/financing-amount?${queryParams}`;
            },
            providesTags: ["analyticalTreeMap"],
            onQueryStarted: snackbarOnQueryStarted({
                errorMessage:"analyticsMapQueryError",
            })
        }),
      
    }),
});

export const {
    useGetAnalyticsQuery
} = analyticalTreeMapApi;
export default analyticalTreeMapApi;
